import { Dispatch, SetStateAction } from "react";
import { AlertState, NotificationState } from "type";

/**
 * the global notification
 */
class Notify {
  static setNotification: Dispatch<SetStateAction<NotificationState>> = () => {};

  static setConfirm: Dispatch<SetStateAction<NotificationState>> = () => {};

  static onClose: () => void = () => {};

  static setAlert: Dispatch<SetStateAction<AlertState>> = () => {};

  static timeoutClose = 5000;
}

export default Notify;
